import logo from './logo.svg';
import './App.css';
import Grid from './components/grid'

function App() {
  return (
    <div className="App">
      <header className="App-header">
      <h1 className="text-3xl font-bold underline">
      Calculator
    </h1>
       < Grid />
      </header>
    </div>
  );
}

export default App;
